import { QuestEstimate, QuestType } from '../../type';
import { useQuery } from 'react-query';
import { CommonDependency } from '@/dependency';
import { useMemo } from 'react';
import { checkDrawDataValid } from '.';
import { checkActionsEmpty } from '../../utils';
import { MaxJoinCount, MinJoinCount } from '../..';

export const PRECISION = 10000;

const select = (res: QuestEstimate) => ({
  discount: res?.discount,
  unit_fee: res?.unit_fee ? res.unit_fee / PRECISION : 0,
  discount_unit_fee: res?.discount_unit_fee ? res.discount_unit_fee / PRECISION : 0,
  final_unit_fee: res?.final_unit_fee ? res.final_unit_fee / PRECISION : 0,
  deposit_fee: res?.deposit_fee ? res.deposit_fee / PRECISION : 0,
  luck_draw_fee: res?.luck_draw_fee ? res.luck_draw_fee / PRECISION : 0,
  deposit_cash: res?.deposit_cash ? res.deposit_cash / PRECISION : 0,
  discount_deposit_cash: res?.discount_deposit_cash ? res.discount_deposit_cash / PRECISION : 0,
  total_deposit: res?.total_deposit ? res.total_deposit / PRECISION : 0,
  base_fee: res?.base_fee ? res.base_fee / PRECISION : 0,
  actions: res.actions,
});

export const useQuestEstimate = ({ quest, enabled }: { quest?: QuestType; enabled: boolean }) => {
  return useQuery(
    ['quest_estimate', quest],
    async (): Promise<QuestEstimate> => CommonDependency.api.getQuestEstimate({ quest }),
    {
      select,
      enabled: !!quest && enabled,
    },
  );
};

export const useTotalQuestEstimate = ({ quest }: { quest?: QuestType }) => {
  const isDrawValid = useMemo(() => {
    if (!quest?.draw_data) {
      // 没有draw_data 也可以进行预估价格
      return true;
    }
    return checkDrawDataValid(quest?.draw_data);
  }, [quest?.draw_data]);

  const isJoinCountValid = useMemo(
    () =>
      !!quest?.estimated_join_count &&
      quest?.estimated_join_count >= MinJoinCount &&
      quest?.estimated_join_count <= MaxJoinCount,
    [quest?.estimated_join_count],
  );

  const isActionEmpty = useMemo(() => checkActionsEmpty(quest?.actions), [quest?.actions]);
  return useQuestEstimate({
    // 查询总价需要全部quest数据
    quest,
    enabled: isJoinCountValid && !isActionEmpty && isDrawValid,
  });
};
